<c-container class="mt-5">
  @if (uiState === uiStateEnumForTemplate.ShowLoading) {
    <mat-spinner></mat-spinner>
  } @else if (uiState === uiStateEnumForTemplate.ShowData) {
    <app-email-players-button [gameId]="null"></app-email-players-button>
    <div class="text-end">
      <button mat-raised-button
              routerLink="/create-broadcast-notification"
              data-testid="add-new-notification-button"
              *hasPermission="permissionTypes.ModifyBroadcastNotifications"
              class="primary-button">
        Add New Notification
      </button>
    </div>

    <app-broadcast-notifications-table [notifications]="broadcastNotifications"></app-broadcast-notifications-table>
  }
</c-container>
